import banner2 from "../assets/images/login_singUp/banner2.png";
import banner3 from "../assets/images/login_singUp/banner3.png";
import laptop_afinando from "@assets/images/login_singUp/laptop-afinando-tag.svg";

export const Banners = [
  {
    image: laptop_afinando,
    title: "Mais de 200 atividades",
    description:
      "Transforme seu cérebro com atividades dinâmicas, diversificadas e repletas de diversão!",
  },
  {
    image: banner2,
    title: "Treine de qualquer lugar",
    description:
      "Treine no seu tempo, em qualquer lugar, e mantenha seu cérebro em movimento.",
  },
  {
    image: banner3,
    title: "Acompanhe seu Progresso",
    description:
      "Visualize suas conquistas e veja como suas habilidades evoluem a cada jogo",
  },
];
